interface BackButtonProps {
  label: string;
  onClick: () => void;
}

export function BackButton({ label, onClick }: BackButtonProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      className="inline-flex min-h-target items-center text-primary hover:text-primary mb-4 self-start"
    >
      ← {label}
    </button>
  );
}
